import { assetParser } from '../../models/Asset'
import * as api from '../api'
import useInvalidate from '../useInvalidate'
import useApiMutation from './useApiMutation'

export interface CreateAssetArguments {
  learningItemUuid: string
  filename: string
  mimeType: string
  content: File
  description?: string
  visibleFrom?: Date
  visibleUntil?: Date
  onProgress?: (e: ProgressEvent) => void
}

export default function useCreateAsset() {
  const invalidate = useInvalidate()

  return useApiMutation({
    mutationFn: async (data: CreateAssetArguments) => {
      const result = await api.postForm(
        `course/${encodeURIComponent(data.learningItemUuid)}/asset`,
        {
          filename: data.filename,
          mime_type: data.mimeType,
          asset: data.content,
          description: data.description,
          visible_from: data.visibleFrom?.toISOString(),
          visible_until: data.visibleUntil?.toISOString(),
        },
        data.onProgress
      )

      await invalidate.assets()

      return assetParser.parse(result)
    },
  })
}
